var _clipPath, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRChartDisc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconR-chart-disc",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,0c11.038,0 20,8.962 20,20c0,11.038 -8.962,20 -20,20c-11.038,0 -20,-8.962 -20,-20c0,-11.038 8.962,-20 20,-20Zm-8.77,25.786l0,-14.143c0,-0.438 -0.355,-0.793 -0.793,-0.793c-0.438,-0 -0.793,0.355 -0.793,0.793c0,-0 0,14.143 0,14.143c0,1.858 1.507,3.364 3.365,3.364l16.714,0c0.436,0 0.793,-0.357 0.793,-0.793c-0,-0.436 -0.357,-0.793 -0.793,-0.793c-0,0 -16.714,0 -16.714,0c-0.983,0 -1.779,-0.796 -1.779,-1.778Zm14.064,-11.079c-0.436,0 -0.792,0.357 -0.792,0.793c-0,0.436 0.356,0.793 0.792,0.793c0,-0 1.23,-0 1.23,-0c0,-0 -3.872,3.873 -3.872,3.873c-0,-0 -3.298,-3.298 -3.298,-3.298c-0.306,-0.311 -0.813,-0.311 -1.121,0.001c0.001,-0.001 -4.499,4.499 -4.499,4.499c-0.31,0.307 -0.31,0.813 0,1.12c0.308,0.313 0.814,0.312 1.121,-0c-0,0 3.904,-3.939 3.904,-3.939c0,-0 3.333,3.297 3.333,3.297c0.306,0.312 0.813,0.312 1.12,-0.001c-0,0.001 4.432,-4.432 4.432,-4.432c0,0 0,1.23 0,1.23c0,0.436 0.357,0.793 0.793,0.793c0.436,-0 0.793,-0.357 0.793,-0.793c0,-0 0,-3.143 0,-3.143c0,-0.436 -0.357,-0.793 -0.793,-0.793l-3.143,0Z",
    style: {
      fill: "#fff"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chart-line-up"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRChartDisc);
export default __webpack_public_path__ + "static/media/iconR-chart-disc.4f57f0a389bd1197adda26d615a36352.svg";
export { ForwardRef as ReactComponent };